import { render, staticRenderFns } from "./index_0.vue?vue&type=template&id=20ce6454&scoped=true"
import script from "./index_0.vue?vue&type=script&lang=js"
export * from "./index_0.vue?vue&type=script&lang=js"
import style0 from "./index_0.vue?vue&type=style&index=0&id=20ce6454&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20ce6454",
  null
  
)

export default component.exports